(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const selectorContainer = document.querySelector('[data-variant-selector]');
    
    // For single variant products, we don't need the selector functionality
    if (!selectorContainer) {
      return;
    }

    const form = selectorContainer.closest('form');
    if (!form) return;
    const productFixedPanel = selectorContainer.closest('.product-fixed-panel');

    // Check vendor flags from the outer product-form wrapper (not the <form> tag)
    const productFormWrapper = selectorContainer.closest('[data-product-form]') || form;
    const isStyleInForm = productFormWrapper.dataset.isStyleInForm === 'true';
    const isCeladon = productFormWrapper.dataset.isCeladon === 'true';

    // Parse product data for variant price lookup
    let productData = {};
    try {
      productData = JSON.parse(form.dataset.product || '{}');
    } catch (e) {
      console.warn('Unable to parse product JSON:', e);
    }

    const moneyFormat = form.dataset.moneyFormat || '${{amount}}';

    // Enhanced money formatting function
    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      // Fallback formatting
      const amount = (cents / 100).toFixed(2);
      return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }

    // MODIFIED: Updated function to get inventory display text with standard logic for all vendors
    // Uses translations from window.LYH_PRODUCT_TRANSLATIONS
    const t = window.LYH_PRODUCT_TRANSLATIONS || {};
    function getInventoryDisplayText(variant) {
      if (isCeladon && (variant.inventory_quantity > 0 || variant.inventory_policy === 'continue')) {
        return t.madeToOrder || 'In Stock (Made to Order)';
      } else if (variant.inventory_quantity > 10) {
        return t.inStock || 'In Stock';
      } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
        return (t.xLeft || '__COUNT__ Left').replace('__COUNT__', variant.inventory_quantity);
      } else if (isStyleInForm && variant.inventory_policy === 'continue' && variant.inventory_quantity <= 0) {
        return t.backordered || 'Backordered';
      } else if (variant.inventory_policy === 'continue') {
        return t.inStock || 'In Stock';
      } else {
        return t.outOfStock || 'Out of Stock';
      }
    }

    // NEW: Function to update product images when variant changes
    function updateProductImages(variant) {
      if (!variant) return;
      // Get the featured image from the variant data
      let variantImage = null;
      let variantImageId = null;

      // Try multiple ways to get the variant image
      if (variant.featured_image) {
        if (typeof variant.featured_image === 'string') {
          variantImage = variant.featured_image;
        } else if (variant.featured_image.src) {
          variantImage = variant.featured_image.src;
          variantImageId = variant.featured_image.id;
        }
      } else if (variant.image) {
        if (typeof variant.image === 'string') {
          variantImage = variant.image;
        } else if (variant.image.src) {
          variantImage = variant.image.src;
          variantImageId = variant.image.id;
        }
      }

      // If no variant image found, don't proceed
      if (!variantImage) {
        console.log('No variant image found for variant:', variant.title);
        return;
      }

      console.log('Switching to variant image:', variantImage, 'for variant:', variant.title);
      // Method 1: Click on thumbnail that matches this image
      // This is the most reliable method for most themes
      const allThumbnails = document.querySelectorAll([
        '.product-single__thumbnail',
        '.product-gallery__thumbnail', 
        '.product-thumb',
        '.thumbnail',
        '[data-image-id]',
        '.product-single__thumbnails img',
        '.product-gallery__thumbnails img',
        '.product-thumbnails img'
      ].join(', '));

      let foundThumbnail = false;
      allThumbnails.forEach(thumb => {
        if (foundThumbnail) return;
        
        // Check if this thumbnail's image matches our variant image
        let thumbSrc = '';
        if (thumb.tagName === 'IMG') {
          thumbSrc = thumb.src || thumb.getAttribute('data-src') || '';
        } else {
          const img = thumb.querySelector('img');
          if (img) {
            thumbSrc = img.src || img.getAttribute('data-src') || '';
          }
        }

        // Extract filename from both URLs for comparison
        const getImageFilename = (url) => {
          if (!url) return '';
          // Remove size parameters and get just the filename
          return url.split('?')[0].split('/').pop().replace(/_\d+x\d*\./, '.');
        };

        const variantFilename = getImageFilename(variantImage);
        const thumbFilename = getImageFilename(thumbSrc);

        // Also check by image ID if available
        const thumbImageId = thumb.getAttribute('data-image-id');
        
        if ((variantFilename && thumbFilename && variantFilename === thumbFilename) ||
            (variantImageId && thumbImageId && variantImageId.toString() === thumbImageId.toString())) {
          console.log('Found matching thumbnail for variant');
          foundThumbnail = true;
          // Note: We no longer click the thumbnail directly as this triggers the lightbox.
          // Instead, Method 3 below uses Flickity's API to navigate to the correct slide.
        }
      });
      // Method 2: If thumbnail click didn't work, try direct image update
      if (!foundThumbnail) {
        console.log('No matching thumbnail found, updating main image directly');
        const mainImageSelectors = [
          '.product-gallery__main img',
          '.product__media img', 
          '.product-single__photo img',
          '.product-image-main img',
          '.featured-image img',
          '.product_slider .product-gallery__main img',
          '[data-product-main-image]',
          '.product-photo-container img',
          '.product-single__photos .is-active img',
          '.product-gallery .active img'
        ];
        mainImageSelectors.forEach(selector => {
          const images = document.querySelectorAll(selector);
          images.forEach(img => {
            if (img) {
              // Store original for potential restoration
              if (!img.getAttribute('data-original-src')) {
                img.setAttribute('data-original-src', img.src);
              }
              
              img.src = variantImage;
              img.srcset = ''; // Clear srcset to prevent conflicts
              
              // Update alt text
              if (variant.title) {
                img.alt = variant.title;
              }
            }
          });
        });
      }

      // Method 3: Try to trigger slider navigation if present
      const sliders = document.querySelectorAll('.flickity-enabled, .slick-initialized, [data-flickity]');
      sliders.forEach(slider => {
        const slides = slider.querySelectorAll('.gallery-cell, .slick-slide, .slide');
        let targetSlideIndex = -1;

        slides.forEach((slide, index) => {
          const slideImg = slide.querySelector('img');
          if (slideImg) {
            const slideSrc = slideImg.src || slideImg.getAttribute('data-src') || '';
            const getImageFilename = (url) => {
              if (!url) return '';
              return url.split('?')[0].split('/').pop().replace(/_\d+x\d*\./, '.');
            };

            const variantFilename = getImageFilename(variantImage);
            const slideFilename = getImageFilename(slideSrc);

            if (variantFilename && slideFilename && variantFilename === slideFilename) {
              targetSlideIndex = index;
            }
          }
        });

        if (targetSlideIndex >= 0) {
          // Flickity
          if (slider.flickity) {
            slider.flickity.select(targetSlideIndex);
          }
          // Slick
          else if (window.jQuery && window.jQuery(slider).slick) {
            window.jQuery(slider).slick('slickGoTo', targetSlideIndex);
          }
          // Basic slider - just show the target slide
          else {
            slides.forEach((slide, index) => {
              if (index === targetSlideIndex) {
                slide.classList.add('is-selected', 'active');
              } else {
                slide.classList.remove('is-selected', 'active');
              }
            });
          }
        }
      });
      // Method 4: Update URL hash for themes that use it
      if (variantImageId) {
        const currentUrl = new URL(window.location);
        currentUrl.hash = `image-${variantImageId}`;
        window.history.replaceState({}, '', currentUrl);
      }
    }

    // FIXED: Enhanced function to update all price elements and availability state
    function updatePricesAndAvailability(variant, productRoot) {
      if (!variant) return;
      productRoot = productRoot || form;
      // Common price selectors used in Shopify themes
      const priceSelectors = [
        '[data-product-price]',
        '.product-price',
        '.price',
        '.product__price',
        '.price-item',
        '.price-item--regular',
        '.price__regular',
        '.money',
        '.current-price',
        '.product-price-wrap .money',
        '.product-single__price',
        '.product-form__price',
        '.product__price-wrap .price',
        '.price-wrapper .price'
      ];
      const compareAtPriceSelectors = [
        '[data-product-compare-price]',
        '.compare-price',
        '.was-price',
        '.price-item--sale',
        '.price__compare',
        '.original-price',
        '.product-price-wrap .compare-at-price',
        '.product-single__price--compare-at',
        '.product-form__price--compare-at',
        '.price-wrapper .compare-at-price'
      ];
      // Update regular price – scoped ONLY to the main product panel
priceSelectors.forEach(selector => {
  const elements = productRoot.querySelectorAll(selector);
  elements.forEach(el => {
    if (el && !el.matches(compareAtPriceSelectors.join(', '))) {
      el.innerHTML = `<span class="money">${formatMoney(variant.price)}</span>`;
    }
  });
});

      // Update compare at price
      compareAtPriceSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          if (el) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              el.innerHTML = `<span class="money">${formatMoney(variant.compare_at_price)}</span>`;
              el.style.display = '';
            } else {
              el.style.display = 'none';
            }
          }
        });
      });
      // Update sale badges
      const saleBadgeSelectors = [
        '.sale-badge',
        '.product-badge--sale',
        '.badge--sale',
        '.product__badge--sale'
      ];
      saleBadgeSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          if (el) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              el.style.display = '';
            } else {
              el.style.display = 'none';
            }
          }
        });
      });
      // Update product form data attributes
      if (form) {
        form.setAttribute('data-variant-id', variant.id);
        form.setAttribute('data-variant-title', variant.title);
      }

      // Update quantity max if inventory management is enabled
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput && variant.inventory_management && variant.inventory_policy === 'deny') {
        quantityInput.setAttribute('max', variant.inventory_quantity);
      }

      // FIXED: Enhanced add to cart button state management with proper text encoding
      const addToCartBtn = form.querySelector('.add_to_cart');
      const addToCartContainer = form.querySelector('.atc-btn-container');
      
      if (addToCartBtn) {
        const btnText = addToCartBtn.querySelector('.text');
        // Determine the correct label based on variant availability (using translations)
        let buttonLabel = t.addToCart || 'Add to Cart';
        if (variant.available === true) {
          buttonLabel = t.addToCart || 'Add to Cart';
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('disabled');
          if (addToCartContainer) {
            addToCartContainer.classList.remove('disabled');
          }
        } else {
          buttonLabel = t.soldOut || 'Sold Out';
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('disabled');
          if (addToCartContainer) {
            addToCartContainer.classList.add('disabled');
          }
        }
        
        // FIXED: Update button text using textContent and parse JSON to remove quotes
        if (btnText) {
          btnText.textContent = buttonLabel;
        }
        
        // FIXED: Update data-label attribute without extra quotes
        addToCartBtn.setAttribute('data-label', buttonLabel);
      }

      // Keep the Klaviyo BIS trigger pointed at the currently selected variant
      // so when the customer clicks it, the modal opens for the right variant.
      // Visibility (ATC vs BIS) is handled purely by CSS via .atc-btn-container.disabled.
      const bisTrigger = form.querySelector('[data-bis-wrapper] .klaviyo-bis-trigger');
      if (bisTrigger) {
        bisTrigger.setAttribute('data-variant-id', variant.id);
      }

      // FIXED: Also update noscript button if it exists
      const noscriptBtn = form.querySelector('noscript .add_to_cart');
      if (noscriptBtn) {
        const noscriptBtnText = noscriptBtn.querySelector('.text');
        if (noscriptBtnText) {
          noscriptBtnText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }
        noscriptBtn.disabled = !variant.available;
        if (variant.available) {
          noscriptBtn.classList.remove('disabled');
        } else {
          noscriptBtn.classList.add('disabled');
        }
      }

      // Update payment button visibility based on availability
      const paymentButton = form.querySelector('.shopify-payment-button');
      if (paymentButton) {
        if (variant.available) {
          paymentButton.style.display = '';
        } else {
          paymentButton.style.display = 'none';
        }
      }

      // Image navigation is handled by MutationObserver in product.liquid
      // (desktop stack reorder + mobile Flickity select) via the hidden input attribute change.
    }

    // NEW: Function to update selected variant checkmark
    function updateSelectedVariantCheckmark(selectedVariantId) {
      const optionItems = selectorContainer.querySelectorAll('.option-item');
      optionItems.forEach(item => {
        const variantId = item.getAttribute('data-variant-id');
        if (variantId === selectedVariantId.toString()) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      });
    }

    const header = selectorContainer.querySelector('[data-selector-header]');
    const optionsList = selectorContainer.querySelector('[data-selector-options]');
    const scrollbarTrack = selectorContainer.querySelector('[data-scrollbar-track]');
    const scrollbarThumb = selectorContainer.querySelector('[data-scrollbar-thumb]');
    const sheetBackdrop = document.querySelector('[data-sheet-backdrop]');
    const variantPopup = document.querySelector('[data-variant-popup]');
    const popupCloseBtn = variantPopup ? variantPopup.querySelector('[data-popup-close]') : null;
    const popupList = variantPopup ? variantPopup.querySelector('[data-popup-list]') : null;
    const popupVariantItems = variantPopup ? variantPopup.querySelectorAll('[data-popup-variant]') : [];
    const popupScrollTrack = variantPopup ? variantPopup.querySelector('[data-popup-scrollbar-track]') : null;
    const popupScrollThumb = variantPopup ? variantPopup.querySelector('[data-popup-scrollbar-thumb]') : null;
    const optionItems = selectorContainer.querySelectorAll('.option-item');
    const hiddenInput = form.querySelector('input[name="id"]');
    const selectedInventorySpan = selectorContainer.querySelector('[data-selected-inventory]');
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    window.matchMedia('(max-width: 768px)').addEventListener('change', function(e) {
      isMobile = e.matches;
      if (!e.matches) {
        closePopup();
      } else {
        window.scrollTo(0, 0);
      }
    });

    // ── Popup custom scrollbar ──
    function initPopupScrollbar() {
      if (!popupScrollTrack || !popupScrollThumb || !popupList) return;
      // Need a frame for layout to settle after display:flex kicks in
      requestAnimationFrame(function() {
        var isScrollable = popupList.scrollHeight > popupList.clientHeight;
        if (!isScrollable) {
          popupScrollTrack.classList.remove('is-active');
          return;
        }
        popupScrollTrack.classList.add('is-active');
        var trackHeight = popupScrollTrack.offsetHeight;
        var thumbRatio = popupList.clientHeight / popupList.scrollHeight;
        var thumbHeight = Math.max(24, trackHeight * thumbRatio);
        popupScrollThumb.style.height = thumbHeight + 'px';
        updatePopupThumbPosition();
      });
    }
    function updatePopupThumbPosition() {
      if (!popupList || !popupScrollThumb || !popupScrollTrack) return;
      var maxScroll = popupList.scrollHeight - popupList.clientHeight;
      if (maxScroll <= 0) return;
      var scrollRatio = popupList.scrollTop / maxScroll;
      var trackH = popupScrollTrack.offsetHeight;
      var thumbH = popupScrollThumb.offsetHeight;
      var maxTop = trackH - thumbH;
      if (maxTop <= 0) return;
      popupScrollThumb.style.top = Math.round(scrollRatio * maxTop) + 'px';
    }
    if (popupList) {
      popupList.addEventListener('scroll', updatePopupThumbPosition, { passive: true });
    }

    // ── iOS modal scroll fix ──
    // Strategy: lock body with position:fixed (reliably stops page scroll on iOS)
    // AND manually drive popup list scrolling via JS touch handlers (because iOS
    // won't let elements inside a fixed body scroll natively).
    var popupIsOpen = false;
    var savedScrollY = 0;
    var popupTouchStartY = 0;
    var popupLastTouchY = 0;

    function lockBodyScroll() {
      savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    }
    function unlockBodyScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }

    // Manually scroll the popup list by tracking touch deltas
    function handlePopupTouchStart(e) {
      popupTouchStartY = e.touches[0].clientY;
      popupLastTouchY = popupTouchStartY;
    }

    function handlePopupListTouchMove(e) {
      if (!popupIsOpen || !popupList) return;
      if (e.cancelable) e.preventDefault(); // Always prevent — we scroll manually

      var touchY = e.touches[0].clientY;
      var deltaY = popupLastTouchY - touchY; // positive = finger moved up = scroll down
      popupLastTouchY = touchY;

      popupList.scrollTop += deltaY;
    }

    // Block all touch scroll on backdrop and non-list areas of popup
    function handleBlockTouchMove(e) {
      if (popupIsOpen && e.cancelable) {
        e.preventDefault();
      }
    }

    if (popupList) {
      popupList.addEventListener('touchstart', handlePopupTouchStart, { passive: true });
      popupList.addEventListener('touchmove', handlePopupListTouchMove, { passive: false });
    }
    if (sheetBackdrop) {
      sheetBackdrop.addEventListener('touchmove', handleBlockTouchMove, { passive: false });
    }
    if (variantPopup) {
      variantPopup.addEventListener('touchstart', handlePopupTouchStart, { passive: true });
      variantPopup.addEventListener('touchmove', function(e) {
        if (!popupIsOpen) return;
        // If touch is on the list, the list handler deals with it
        if (popupList && popupList.contains(e.target)) return;
        // Otherwise block
        if (e.cancelable) e.preventDefault();
      }, { passive: false });
    }

    function openPopup() {
      if (sheetBackdrop) sheetBackdrop.classList.add('is-visible');
      if (variantPopup) {
        var currentId = hiddenInput ? hiddenInput.value : '';
        popupVariantItems.forEach(function(item) {
          if (item.getAttribute('data-variant-id') === currentId) {
            item.classList.add('selected');
          } else {
            item.classList.remove('selected');
          }
        });
        variantPopup.classList.add('is-visible');
        popupIsOpen = true;
        lockBodyScroll();
        initPopupScrollbar();
      }
    }
    function closePopup() {
      if (sheetBackdrop) sheetBackdrop.classList.remove('is-visible');
      if (variantPopup) variantPopup.classList.remove('is-visible');
      popupIsOpen = false;
      unlockBodyScroll();
    }
    function closeDropdown() {
      selectorContainer.classList.remove('open');
      if (isMobile) {
        closePopup();
      }
    }

    // Custom scrollbar: position track over dropdown & sync thumb with scroll
    function initCustomScrollbar() {
      if (!scrollbarTrack || !scrollbarThumb || !optionsList) return;
      var isScrollable = optionsList.scrollHeight > optionsList.clientHeight;
      if (!isScrollable) {
        scrollbarTrack.classList.remove('is-active');
        return;
      }
      // Position track to overlay the dropdown list
      var listRect = optionsList.getBoundingClientRect();
      var parentRect = selectorContainer.getBoundingClientRect();
      var trackTop = listRect.top - parentRect.top + 4;
      var trackHeight = listRect.height - 8;
      scrollbarTrack.style.top = trackTop + 'px';
      scrollbarTrack.style.height = trackHeight + 'px';
      scrollbarTrack.classList.add('is-active');
      // Size the thumb proportionally
      var thumbRatio = optionsList.clientHeight / optionsList.scrollHeight;
      var thumbHeight = Math.max(24, trackHeight * thumbRatio);
      scrollbarThumb.style.height = thumbHeight + 'px';
      updateThumbPosition(trackHeight, thumbHeight);
    }

    function updateThumbPosition(trackH, thumbH) {
      if (!optionsList || !scrollbarThumb || !scrollbarTrack) return;
      var maxScroll = optionsList.scrollHeight - optionsList.clientHeight;
      if (maxScroll <= 0) return;
      var scrollRatio = optionsList.scrollTop / maxScroll;
      var tH = trackH || (parseFloat(scrollbarTrack.style.height) || 0);
      var thH = thumbH || scrollbarThumb.offsetHeight;
      var maxTop = tH - thH;
      if (maxTop <= 0) return;
      scrollbarThumb.style.top = Math.round(scrollRatio * maxTop) + 'px';
    }

    // Update scroll shadow classes + scrollbar thumb
    function updateScrollState() {
      var threshold = 10;
      var atTop = optionsList.scrollTop < threshold;
      var atBottom = (optionsList.scrollHeight - optionsList.scrollTop - optionsList.clientHeight) < threshold;
      if (atTop) {
        selectorContainer.classList.remove('scrolled-from-top');
      } else {
        selectorContainer.classList.add('scrolled-from-top');
      }
      if (atBottom) {
        selectorContainer.classList.add('scrolled-to-bottom');
      } else {
        selectorContainer.classList.remove('scrolled-to-bottom');
      }
      updateThumbPosition();
    }

    // ── Mobile scroll-trap ──
    // On iOS Safari, scrollable elements at their boundary (scrollTop=0 or at max)
    // pass the touch scroll to the page. Fix: nudge scrollTop off the boundary on
    // touchstart so iOS keeps the scroll inside the element. No body lock needed.
    optionsList.addEventListener('touchstart', function(e) {
      var top = optionsList.scrollTop;
      var totalScroll = optionsList.scrollHeight;
      var currentScroll = top + optionsList.clientHeight;
      // If at the very top, nudge down 1px
      if (top <= 0) {
        optionsList.scrollTop = 1;
      }
      // If at the very bottom, nudge up 1px
      if (currentScroll >= totalScroll) {
        optionsList.scrollTop = top - 1;
      }
    }, { passive: true });

    // Only attach click listener if there's more than one variant
    const isSingleVariant = selectorContainer.classList.contains('single-variant');
    if (!isSingleVariant) {
      header.addEventListener('click', () => {
        if (isMobile) {
          // On mobile, open the popup instead of inline dropdown
          openPopup();
          return;
        }
        selectorContainer.classList.toggle('open');
        if (selectorContainer.classList.contains('open')) {
          selectorContainer.classList.remove('scrolled-to-bottom');
          selectorContainer.classList.remove('scrolled-from-top');
          // After open animation, init scrollbar and check overflow
          setTimeout(function() {
            if (optionsList.scrollHeight <= optionsList.clientHeight) {
              selectorContainer.classList.add('scrolled-to-bottom');
            }
            initCustomScrollbar();
          }, 350);
        }
      });
      // Close dropdown when clicking outside of it (desktop)
      document.addEventListener('click', (event) => {
        if (!isMobile && !selectorContainer.contains(event.target) && !isSingleVariant) {
          selectorContainer.classList.remove('open');
        }
      });
      // Close popup on backdrop tap or close button
      if (sheetBackdrop) {
        sheetBackdrop.addEventListener('click', closePopup);
      }
      if (popupCloseBtn) {
        popupCloseBtn.addEventListener('click', closePopup);
      }

      // Wire popup variant items to select variant and close.
      // Sold-out variants are intentionally selectable; the Klaviyo BIS button surfaces
      // once they're selected so the customer can sign up for restock notifications.
      popupVariantItems.forEach(function(popupItem) {
        popupItem.addEventListener('click', function() {
          var variantId = popupItem.getAttribute('data-variant-id');
          // Find and click the matching option in the original dropdown
          var matchingOption = selectorContainer.querySelector('.option-item[data-variant-id="' + variantId + '"]');
          if (matchingOption) {
            matchingOption.click();
          }
          // Update selected state in popup
          popupVariantItems.forEach(function(item) { item.classList.remove('selected'); });
          popupItem.classList.add('selected');
          // Close popup after selection
          closePopup();
        });
      });

      // Sync scroll state + custom scrollbar thumb on scroll (desktop)
      optionsList.addEventListener('scroll', updateScrollState);
    }

    // Handle option selection.
    // Sold-out variants are intentionally selectable; the Klaviyo BIS button surfaces
    // once they're selected so the customer can sign up for restock notifications.
    optionItems.forEach(option => {
      option.addEventListener('click', (event) => {
        const variantId = option.getAttribute('data-variant-id');
        const variantTitle = option.querySelector('.option-title').textContent;
        const variantPrice = option.getAttribute('data-variant-price');
        const variantComparePrice = option.getAttribute('data-variant-compare-price');
        const variantAvailable = option.getAttribute('data-variant-available') === 'true';
        const variantInventory = parseInt(option.getAttribute('data-variant-inventory'));
        const variantInventoryManagement = option.getAttribute('data-variant-inventory-management');
        const variantInventoryPolicy = option.getAttribute('data-variant-inventory-policy');
        const variantImage = option.getAttribute('data-variant-image');

        // Update the header with the selected variant's info
        const selectedTitleText = header.querySelector('.selected-variant-title-text');
        if (selectedTitleText) {
          selectedTitleText.textContent = variantTitle;
        }

        const selectedVariant = {
          id: variantId,
          title: variantTitle,
          price: variantPrice,
          compare_at_price: variantComparePrice,
          available: variantAvailable,
          inventory_quantity: variantInventory,
          inventory_management: variantInventoryManagement,
          inventory_policy: variantInventoryPolicy,
          featured_image: { src: variantImage }
        };

        if (selectedInventorySpan) {
            selectedInventorySpan.textContent = getInventoryDisplayText(selectedVariant);
            // MODIFIED: Add/remove inventory classes based on 10-item threshold
            selectedInventorySpan.classList.remove('low-inventory', 'backordered', 'in-stock-high');
            if (isCeladon && (selectedVariant.inventory_quantity > 0 || selectedVariant.inventory_policy === 'continue')) {
                selectedInventorySpan.classList.add('in-stock-high');
            } else if (isStyleInForm && selectedVariant.inventory_policy === 'continue' && selectedVariant.inventory_quantity <= 0) {
                selectedInventorySpan.classList.add('backordered');
            } else if (selectedVariant.inventory_quantity <= 10 && selectedVariant.inventory_quantity > 0) {
                selectedInventorySpan.classList.add('low-inventory');
            } else if (selectedVariant.inventory_quantity > 10 || selectedVariant.inventory_policy === 'continue') {
                selectedInventorySpan.classList.add('in-stock-high');
            }
        }

        // Update hidden input with the new variant ID
        if (hiddenInput) {
          hiddenInput.value = variantId;
          hiddenInput.setAttribute('value', variantId);
          if (productFormWrapper.dataset.enableState === 'true') {
            const selectedUrl = new URL(window.location.href);
            if (selectedUrl.searchParams.get('variant') !== variantId) {
              selectedUrl.searchParams.set('variant', variantId);
              window.history.replaceState(window.history.state, '', selectedUrl.toString());
            }
          }
        }

        // NEW: Update selected variant checkmark
        updateSelectedVariantCheckmark(variantId);

        // Update prices and availability
        updatePricesAndAvailability(selectedVariant, productFixedPanel);

        // Close the dropdown
        closeDropdown();
      });
    });
    
    // FIXED: Function to set initial state of the selected variant display with proper red color styling
    function setInitialVariantState() {
        if (productData.variants && productData.variants.length > 0) {
            const currentVariantId = hiddenInput ? parseInt(hiddenInput.value, 10) : productData.variants[0].id;
            const currentVariant = productData.variants.find(v => v.id === currentVariantId) || productData.variants[0];
            
            // NEW: Set initial checkmark
            updateSelectedVariantCheckmark(currentVariantId);
            
            if (currentVariant && selectedInventorySpan) {
                selectedInventorySpan.textContent = getInventoryDisplayText(currentVariant);
                // FIXED: Properly apply classes for initial variant state with Style In Form check
                selectedInventorySpan.classList.remove('low-inventory', 'backordered', 'in-stock-high');
                if (isCeladon && (currentVariant.inventory_quantity > 0 || currentVariant.inventory_policy === 'continue')) {
                    selectedInventorySpan.classList.add('in-stock-high');
                } else if (isStyleInForm && currentVariant.inventory_policy === 'continue' && currentVariant.inventory_quantity <= 0) {
                    selectedInventorySpan.classList.add('backordered');
                } else if (currentVariant.inventory_quantity <= 10 && currentVariant.inventory_quantity > 0) {
                    selectedInventorySpan.classList.add('low-inventory');
                } else if (currentVariant.inventory_quantity > 10 || currentVariant.inventory_policy === 'continue') {
                    selectedInventorySpan.classList.add('in-stock-high');
                }
            }
        } else {
            // Fallback: check the liquid-rendered initial state and ensure correct styling is applied
            if (selectedInventorySpan) {
                const inventoryText = selectedInventorySpan.textContent.trim();
                const isLowInventory = /^\d+\s/.test(inventoryText) && parseInt(inventoryText) <= 10;
                const isBackordered = inventoryText === 'Backordered';
                const isInStock = inventoryText === 'In Stock' || inventoryText.toLowerCase().includes('in stock') || inventoryText === 'In Stock (Made to Order)';

                selectedInventorySpan.classList.remove('low-inventory', 'backordered', 'in-stock-high');
                if (isBackordered) {
                    selectedInventorySpan.classList.add('backordered');
                } else if (isLowInventory) {
                    selectedInventorySpan.classList.add('low-inventory');
                } else if (isInStock) {
                    selectedInventorySpan.classList.add('in-stock-high');
                }
            }
            
            // NEW: Set initial checkmark for fallback case
            const currentVariantId = hiddenInput ? hiddenInput.value : null;
            if (currentVariantId) {
                updateSelectedVariantCheckmark(currentVariantId);
            }
        }
    }
    

    // Set the initial state on page load
    setInitialVariantState();

    // ── Variant Image Rail: click → select variant, sync highlights ──
    const variantRail = document.querySelector('.pdp-variant-rail');
    if (variantRail) {
      const railBtns = variantRail.querySelectorAll('.pdp-variant-rail__btn[data-variant-id]');

      // Keep the scroll movement scoped to the rail. scrollIntoView can move
      // the page viewport horizontally in Safari/Chrome when the rail is near
      // the right edge, leaving a blank column beside the layout.
      function centerRailBtn(btn, behavior) {
        var track = btn.closest('.pdp-variant-rail__track');
        if (!track) return;
        var targetLeft = btn.offsetLeft - Math.max(0, (track.clientWidth - btn.offsetWidth) / 2);
        track.scrollTo({ left: Math.max(0, targetLeft), behavior: behavior || 'smooth' });
        if (window.scrollX) {
          window.scrollTo({ left: 0, top: window.scrollY, behavior: 'auto' });
        }
      }

      // Click handler: select variant via the existing option-item click path.
      // Sold-out variants are intentionally selectable.
      railBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var vid = btn.getAttribute('data-variant-id');
          var matchingOption = selectorContainer.querySelector('.option-item[data-variant-id="' + vid + '"]');
          if (matchingOption) {
            matchingOption.click();
          }
          // Update rail selection state
          railBtns.forEach(function(b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          centerRailBtn(btn);
        });
      });

      // Sync rail highlight when variant changes from other UI (dropdown, popup)
      // and scroll the rail so the newly selected card is visible.
      function syncRailToVariant(variantId, scrollBehavior) {
        railBtns.forEach(function(b) {
          var match = b.getAttribute('data-variant-id') === String(variantId);
          b.classList.toggle('is-selected', match);
          b.setAttribute('aria-pressed', match ? 'true' : 'false');
          if (match) {
            centerRailBtn(b, scrollBehavior);
          }
        });
      }

      // On page load, bring the initially selected variant into view (no animation).
      if (hiddenInput && hiddenInput.value) {
        syncRailToVariant(hiddenInput.value, 'auto');
      }

      // Observe hidden input changes to keep rail in sync
      if (hiddenInput) {
        var railObserver = new MutationObserver(function() {
          syncRailToVariant(hiddenInput.value);
        });
        railObserver.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
        hiddenInput.addEventListener('change', function() {
          syncRailToVariant(hiddenInput.value);
        });
      }

      // ── Manual touch drag-scroll (variant popup pattern) ──
      // On real iOS the native horizontal pan on this track doesn't engage,
      // even though programmatic scrolling works. Drive the scroll manually
      // from touch events instead: horizontal drags scroll the rail, vertical
      // drags are left alone so the page still scrolls normally.
      (function() {
        var track = variantRail.querySelector('.pdp-variant-rail__track');
        if (!track) return;
        var startX = 0, startY = 0, startLeft = 0, lastDx = 0;
        var active = false, axis = null;

        track.addEventListener('touchstart', function(e) {
          if (e.touches.length !== 1) { active = false; return; }
          active = true;
          axis = null;
          lastDx = 0;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          startLeft = track.scrollLeft;
        }, { passive: true });

        track.addEventListener('touchmove', function(e) {
          if (!active || e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;
          if (!axis) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; // not moved enough yet
            axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          }
          if (axis !== 'x') return; // vertical intent: let the page scroll
          if (e.cancelable) e.preventDefault(); // we scroll manually
          lastDx = dx;
          track.scrollLeft = startLeft - dx;
        }, { passive: false });

        function endDrag() {
          if (active && axis === 'x' && Math.abs(lastDx) > 10) {
            // A real drag happened — swallow the click that iOS may still
            // fire on the card under the finger.
            var suppress = function(ev) {
              ev.preventDefault();
              ev.stopPropagation();
            };
            track.addEventListener('click', suppress, { capture: true, once: true });
            setTimeout(function() {
              track.removeEventListener('click', suppress, { capture: true });
            }, 400);
          }
          active = false;
          axis = null;
        }
        track.addEventListener('touchend', endDrag, { passive: true });
        track.addEventListener('touchcancel', endDrag, { passive: true });
      })();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
